export enum RecipientType {
    User = 1,
    Group = 2,
    WorkGroup = 3,
}
